import apiService from './api';

const FAMILY_URL = '/families';

// Create a new family
export const createFamily = async (familyData) => {
  try {
    const response = await apiService.post(FAMILY_URL, familyData);
    return response;
  } catch (error) {
    console.error('Failed to create family:', error);
    throw error;
  }
};

// Get all families for the current user
export const getUserFamilies = async () => {
  try {
    const response = await apiService.get(FAMILY_URL);
    return response;
  } catch (error) {
    console.error('Failed to get families:', error);
    throw error;
  }
};

// Get a family by ID
export const getFamilyById = async (familyId) => {
  try {
    const response = await apiService.get(`${FAMILY_URL}/${familyId}`);
    return response;
  } catch (error) {
    console.error('Failed to get family:', error);
    throw error;
  }
};

// Update a family
export const updateFamily = async (familyId, familyData) => {
  try {
    const response = await apiService.put(`${FAMILY_URL}/${familyId}`, familyData);
    return response;
  } catch (error) {
    console.error('Failed to update family:', error);
    throw error;
  }
};

// Delete a family
export const deleteFamily = async (familyId) => {
  try {
    const response = await apiService.delete(`${FAMILY_URL}/${familyId}`);
    return response;
  } catch (error) {
    console.error('Failed to delete family:', error);
    throw error;
  }
};

// Join a family using a join code
export const joinFamily = async (joinData) => {
  try {
    const response = await apiService.post(`${FAMILY_URL}/join`, joinData);
    return response;
  } catch (error) {
    console.error('Failed to join family:', error);
    throw error;
  }
};

// Refresh a family's join code
export const refreshJoinCode = async (familyId) => {
  try {
    const response = await apiService.post(`${FAMILY_URL}/${familyId}/refresh-code`);
    return response;
  } catch (error) {
    console.error('Failed to refresh join code:', error);
    throw error;
  }
};

// Leave a family
export const leaveFamily = async (familyId) => {
  try {
    const response = await apiService.delete(`${FAMILY_URL}/${familyId}/leave`);
    return response;
  } catch (error) {
    console.error('Failed to leave family:', error);
    throw error;
  }
};

// Get all readers in a family
export const getFamilyReaders = async (familyId) => {
  try {
    const response = await apiService.get(`${FAMILY_URL}/${familyId}/readers`);
    return response;
  } catch (error) {
    console.error('Failed to get family readers:', error);
    throw error;
  }
};

// Get reading statistics for a family
export const getFamilyStats = async (familyId) => {
  try {
    const response = await apiService.get(`${FAMILY_URL}/${familyId}/stats`);
    return response;
  } catch (error) {
    console.error('Failed to get family stats:', error);
    throw error;
  }
}; 